export var getTitleProps = function getTitleProps(layoutType) {
  switch (layoutType) {
    case 'mobile':
    case 'tablet':
      return {
        purpose: 'headline',
        size: 'l'
      };
    default:
      return {
        purpose: 'display',
        size: 'm'
      };
  }
};
export var getSliderContentWrapperImageType = function getSliderContentWrapperImageType(media) {
  switch (media.type) {
    case 'image':
      return media.format;
    case 'imageBg':
    case 'videoBg':
    default:
      return undefined;
  }
};